export default __webpack_public_path__ + "static/media/related_02.8fd178ed.png";